import RulesPageDefault from "../../../../components/Rules/RulesPageDefault";

export default function() {
    return (
        <div>
            <RulesPageDefault title="D. Core Rules (In-Depth)"/>
        </div>
    )
}